
// Responsive iframe child portion of embed code.
import * as pym from 'pym.js';

const pymChild = new pym.Child();

export default pymChild;
